import { callAPI, HTTPMethod } from "./API";
import { Expressions, Expression, ExpressionsQueryParams, ExpressionRequest, ExpressionTestRequest } from "../model/Expression";

const basePath = (tenantId: string) => `/tenants/${tenantId}/expressions`;

export async function listExpressions(tenantId: string, page: number, offset: number, params: ExpressionsQueryParams): Promise<Expressions> {
    return await callAPI(`${basePath(tenantId)}`, {
        method: HTTPMethod.GET,
        query: {
            search: params.search,
            pageSize: page.toString(),
            offset: offset.toString()
        }
    });
}

export async function createExpression(tenantId: string, request: ExpressionRequest): Promise<Expression> {
    return await callAPI(`${basePath(tenantId)}`, {
        method: HTTPMethod.POST,
        body: request
    });
}

export async function getExpression(tenantId: string, id: string): Promise<Expression> {
    return await callAPI(`${basePath(tenantId)}/${id}`, {
        method: HTTPMethod.GET
    });
}

export async function updateExpression(tenantId: string, id: string, request: ExpressionRequest): Promise<Expression> {
    return await callAPI(`${basePath(tenantId)}/${id}`, {
        method: HTTPMethod.PUT,
        body: request
    });
}

export async function deleteExpression(tenantId: string, id: string): Promise<any> {
    return await callAPI(`${basePath(tenantId)}/${id}`, {
        method: HTTPMethod.DELETE
    });
}

export async function testExpression(tenantId: string, id: string, request: ExpressionTestRequest): Promise<any> {
    return await callAPI(`${basePath(tenantId)}/${id}/test-expression`, {
        method: HTTPMethod.POST,
        body: request
    });
}
